
export enum EModeVideProject {
    kanban,
    list,
    gantt
}

export type TProjectStatus = 'Finished' | 'Ongoing';

export interface IUserProject {
    id: number;
    name: string;
    avatar?: string;
}
export interface ProjectCardProps {
    code: string;
    name?: string;
    description?: string;
    members?: IUserProject[];
    percent?: number;
    status?: TProjectStatus
    avatar?: string;
    total_cmd?: number;
    total_task?: number;
}
// edit, completed, pending, in_progress, delete
export enum EProjectActions {
    EDIT = 'edit',
    COMPLETED = 'completed',
    PENDING = 'pending',
    REOPEN = 'reopen',
    IN_PROGRESS = 'in_progress',
    DELETE = 'delete',
    ATTACHMENT = 'attachment',
}

export enum ETaskActions {
    EDIT = 'edit',
    CLOSED = 'closed',
    OPEN = 'open',
    UPDATE = 'update',
    ADD = 'add',
    DETACH = 'detach',
    ATTACHMENT = 'attachment',
    DELETE = 'delete',
    PAGINATE = 'paginate',
    SHOW_FILTER = 'show_filter',
}

export enum ETypeTaskGantt {
    PROJECT = 'project',
    TASK = 'task',
    MILESTONE = 'milestone',
}